/**
 * Säljare utan egen e-post får en påhittad adress på en egen subdomän, som
 * aldrig tar emot mejl. Riktiga adresser på coffeenova.se (t.ex.
 * info@coffeenova.se) är vanliga konton och ska få mejl som alla andra.
 * Delas av API:t och appen så att regeln bara finns på ett ställe.
 */
export const PLACEHOLDER_EMAIL_DOMAIN = 'saljare.coffeenova.se';

export const placeholderEmail = (slug: string) => `${slug}@${PLACEHOLDER_EMAIL_DOMAIN}`;

export const isPlaceholderEmail = (email: string | null | undefined): boolean =>
    !!email && email.trim().toLowerCase().endsWith(`@${PLACEHOLDER_EMAIL_DOMAIN}`);

/**
 * Det man skriver i inloggningen: en e-postadress eller en säljkod. En
 * säljkod ("anna-k7m2") blir säljarens påhittade adress.
 */
export const loginEmail = (input: string): string => {
    const value = input.trim().toLowerCase();
    return value && !value.includes('@') ? placeholderEmail(value) : value;
};
